module.exports = __webpack_public_path__ + "static/media/js.e6bfc6e5.png";